import { InjectionToken, Provider } from '@angular/core'
import { InflightPromise } from 'shared-services'
import {
  IdentityConfig,
  InflightUserGetterService,
  UserGetterService,
  UserGetterServiceImpl,
} from 'identity-services'
import { identityConfigToken } from './identity-config.token'

export const userGetterServiceToken = new InjectionToken<UserGetterService>(
  'UserGetterServiceToken',
)

export const userGetterServiceProvider: Provider = {
  provide: userGetterServiceToken,
  useFactory: (
    identityConfig: IdentityConfig,
    inflightPromise: InflightPromise,
  ): UserGetterService => {
    const service = new UserGetterServiceImpl(identityConfig)
    return new InflightUserGetterService(service, inflightPromise)
  },
  deps: [identityConfigToken, InflightPromise],
}
